import SearchTextField, { SearchTextFieldStyles } from "@eisinc/Overrides/Widgets/OrderHistory/SearchTextField";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { OrderHistoryPageContext } from "@insite/content-library/Pages/OrderHistoryPage";
import * as React from "react";

export const orderedByStyles: SearchTextFieldStyles = {};
const styles = orderedByStyles;

const OrderHistorySearchFieldOrderedBy: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="orderedBy"
            label="Ordered By"
            inputType="text"
            placeholder=""
            testSelector="orderHistory_filterOrderedBy"
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFieldOrderedBy,
    definition: {
        group: "Order History",
        allowedContexts: [OrderHistoryPageContext],
        displayName: "Order By",
    },
};

export default widgetModule;
